<style>
.el-collapse-item__header {
  padding-left: 15px;
}
.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}
.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}
.v-modal {
  z-index: 100 !important;
}
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}

</style>
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="8"
          ><div class="search-area-div">考核内容：</div>
          <el-input  size="mini" v-model="page.evaluationContent" class="ipt-sty" placeholder="请输入考核内容"></el-input
        ></el-col>
        <div style="float: left">
          <el-button size="mini" type="info" @click="search">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
        </div>
      </el-row>
    </div>


    <div class="back-color-fff content-main-box"  :style="'height:' + contentMainHeight + 'px;'">
      <div class="button-area" style="display:flex;justify-content:space-between;">
        <div>
          <el-button size="mini" type="info" v-if="getBtnPermissionsByName('新增考核内容')" @click="addVersion">新增考核内容</el-button>
          <el-button size="mini" type="info" v-if="getBtnPermissionsByName('批量复制')" @click="toBulkCopy">批量复制</el-button>
          <el-button  v-if="getBtnPermissionsByName('审核界面排序')"  class="sort-btn" size="mini" type="info" @click="dialogIssues = true;changeTab(checkedTab);">审核界面排序设置</el-button>
        </div>
      </div>
      <el-table :data="tableData" border style="width: 100%" v-loading="tableLoading" :height="height">
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="campaignsState"
          label="考核内容"
          width="240px"
          show-overflow-tooltip
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">{{ scope.row.evaluationContent }}</template>
        </el-table-column>
        <el-table-column label="展示顺序" width="80" header-align="center" align="right">
          <template slot-scope="scope">
            {{ scope.row.orderNum }}
          </template>
        </el-table-column>
        <el-table-column prop="createUserName" width="100" label="创建人" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.createUserName }}</template>
        </el-table-column>
        <el-table-column prop="createTime" width="140" label="创建时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.createTime | getTime }}</template>
        </el-table-column>
        <el-table-column width="150" label="操作" header-align="center" align="center" v-if="getBtnPermissionsByName('设置考核机制') || getBtnPermissionsByName('编辑') || getBtnPermissionsByName('删除')">
          <template slot-scope="scope">
            <a class="txt-color" v-if="getBtnPermissionsByName('设置考核机制')" @click="setCheck(scope.row)">设置考核机制 </a>
            <a class="txt-color" v-if="getBtnPermissionsByName('编辑')" @click="editVersion(scope.row)">编辑 </a>
            <a class="txt-color" v-if="getBtnPermissionsByName('删除')" @click="delVersion(scope.row.guid)">删除 </a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff content-pagination-box"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10,20,50 ,100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <el-dialog :title="textTitle" :visible.sync="dialogVisible" width="460px" top="30vh">
      <el-form label-width="140px" :label-position="right" class="demo-ruleForm">
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">考核内容</span>
          <el-input type="input" :maxlength="30" placeholder="请输入任务大类名称" v-model="evaluationContent">
          </el-input>
        </el-form-item>
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">展示顺序</span>
          <el-input type="number" placeholder="请填写排序" v-model="orderNum"> </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="dialogVisible = false">取 消</el-button>
        <el-button
          size="medium"
          type="info"
          v-if="textTitle == '新增考核内容'"
          @click="addReqVersion"
          v-loading.fullscreen.lock="fullscreenLoading"
          >确 定</el-button
        >
        <el-button
          size="medium"
          type="info"
          v-else
          @click="updateReqVersion"
          v-loading.fullscreen.lock="fullscreenLoading"
          >修 改</el-button
        >
      </span>
    </el-dialog>

    <el-dialog :title="dialogTxt" :visible.sync="dialogCheckVisible" width="1200px">
      <div class="content-main-box">
        <div>
          <el-form>
            <el-row>
              <el-col :span="10">
                <el-form-item label="考核要求:">
                  <el-input v-model="evaluationRuleDesc" class="ipt-sty" placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4" style="padding-top:5px">
                <el-button size="mini" type="info" @click="getDetailList()">搜索</el-button>
                <el-button size="mini" type="danger" @click="evaluationRuleDesc = '';getDetailList()">清空</el-button>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div style="float: left; margin-bottom: 20px">
          <el-button size="mini" type="info" @click="addRow">新增</el-button>
        </div>
        <el-table :data="evaluationTable" border style="width: 100%">
          <el-table-column label="序号" width="50" header-align="center" align="center">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>

          <el-table-column label="考核类型" header-align="center" align="center">
            <template slot-scope="scope">
              <el-select filterable v-model="scope.row.evaluationType" placeholder="请选择">
                <el-option
                  v-for="(item, index) in evaluationTypeList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column label="是否合格" header-align="center" align="center">
            <template slot-scope="scope">
              <el-select filterable v-model="scope.row.isPass" v-if="scope.row.evaluationType==2" placeholder="请选择">
                <el-option
              
                  v-for="(item, index) in isPassList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>


          <el-table-column label="考核要求" header-align="center" align="center" min-width="250">
            <template slot-scope="scope">
              <el-input
                type="input"
                style="width: 100%; text-align: right; float: left"
                :maxlength="30"
                placeholder="请输入"
                v-model="scope.row.evaluationRuleDesc"
              />
            </template>
          </el-table-column>
          

          <el-table-column label="最低数量要求" header-align="center" align="center" width="110">
            <template slot-scope="scope">
              <el-input
                class="check-table-input"
                type="input"
                style="width: 100%; text-align: right; float: left"
                :maxlength="30"
                placeholder="请输入"
                v-model="scope.row.minQuantity"
                onkeyup="value=value.replace(/[^\d]/g,'')"
              />
            </template>
          </el-table-column>

          <el-table-column label="扣罚金额(元)" header-align="center" align="center" width="110">
            <template slot-scope="scope">
              <el-input
                class="check-table-input"
                type="input"
                style="width: 100%; text-align: right; float: left"
                :maxlength="30"
                placeholder="请输入"
                v-model="scope.row.cutPayment"
                onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
              />
            </template>
          </el-table-column>
      
          
          <el-table-column label="奖励金额(元)" header-align="center" align="center" width="110">
            <template slot-scope="scope">
              <el-input
                class="check-table-input"
                type="input"
                style="width: 100%; text-align: right; float: left"
                :maxlength="30"
                placeholder="请输入"
                v-model="scope.row.award"
                onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
              />
            </template>
          </el-table-column>
          <el-table-column label="扣罚比列(%)" header-align="center" align="center" width="110">
            <template slot-scope="scope">
              <el-input
                class="check-table-input"
                type="input"
                style="width: 100%; float: left"
                :maxlength="30"
                placeholder="请输入"
                v-model="scope.row.cutRate"
                onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
              />
            </template>
          </el-table-column>
          <el-table-column label="奖励比例(%)" header-align="center" align="center" width="110">
            <template slot-scope="scope">
              <el-input
                class="check-table-input"
                type="input"
                style="width: 100%; float: left"
                :maxlength="30"
                placeholder="请输入"
                v-model="scope.row.awardRate"
                onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
              />
            </template>
          </el-table-column>

          <!-- <el-table-column label="规则标签" header-align="center" align="center" width="110">
            <template slot-scope="scope">
              <el-select filterable v-model="scope.row.ruleTag" placeholder="请选择">
                <el-option
                  v-for="(item, index) in getCodeListByKey('规则标签')"
                  :key="index"
                  :label="item.text"
                  :value="item.value"
                ></el-option>
              </el-select>
            </template>
          </el-table-column> -->

          <el-table-column prop="bank" min-width="50px" label="操作" header-align="center" fixed="right" align="center">
            <template slot-scope="scope">
              <a class="txt-color" @click="delRow(scope.$index)">删除</a>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
          <el-button size="mini" plain @click="dialogCheckVisible = false">取 消</el-button>
          <el-button
            size="mini"
            type="info"
            @click="saveEvaluationContent"
            v-loading.fullscreen.lock="fullscreenLoading"
            >保 存</el-button
          >
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" :visible.sync="dialogIssues" width="50%">
      <div slot="title" class="dialog-title">
        {{ '审核界面排序设置' }}
      </div>
      <div class="dialogCon">
        <div style="padding-bottom:10px">
          <el-radio-group v-model="checkedTab" @input="changeTab" size="small">
            <el-radio-button v-loading.fullscreen.lock="fullscreenLoading" label="Y">合格</el-radio-button>
            <el-radio-button v-loading.fullscreen.lock="fullscreenLoading" label="N" >不合格</el-radio-button>
            <el-radio-button v-loading.fullscreen.lock="fullscreenLoading" label="P">部分合格</el-radio-button>
          </el-radio-group>
        </div>
        <div class="dialogCon-checkbox">
          <el-form>
            <el-form-item>
              <div v-for="(item, index) in reasonList" :key="index">
                <div class="reason-title">{{ item.evaluationContent }}</div>
                <Draggable v-model="item.list" :group="item.evaluationContent" v-if="Array.isArray(item.list)" chosen-class="chosen" force-fallback="true" animation="1000" @start="draggableStart(item.list)" @sort="getSort">
                  <transition-group>
                    <div class="reason-content nowrap-ellipsis" v-for="(reasonItem, reasonIndex) in item.list" :key="reasonIndex">
                      <span class="reason-content-item">{{ `${reasonIndex + 1}、${reasonItem.evaluationRuleDesc}` }}</span>
                    </div>
                  </transition-group>
                </Draggable>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogIssues = false">取 消</el-button>
        <el-button size="mini" type="info" v-loading.fullscreen.lock="fullscreenLoading" @click="confirmSort">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import btnPermisson from '../mixins/btnPermisson';
import { route } from '@/api/apiRoute';
import store from '@/store';
import draggable from 'vuedraggable';
import { getSortList } from '@/uilt/tool';
export default {
  components: {
    Draggable: draggable,
  },
  mixins:[btnPermisson],
  data() {
    return {
      evaluationRuleDesc:'', // 考核要求搜索
      fullscreenLoading: false,
      textTitle: '新增任务大类',
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: localStorage.guid,
        evaluationContent: '',
      },
      evaluationContent: '',
      orderNum: '',
      height: window.innerHeight - 260,
      contentMainHeight: window.innerHeight - 200,
      right: 'right',
      tableData: [],
      dialogVisible: false,
      dialogIssues : false, // 审核原因排序设置弹框
      dialogTxt: '设置考核机制',
      dialogCheckVisible: false,
      evaluationTable: [],
      taskEvaluationGuid: '',
      evaluationTypeList: [
        { label: '数量要求', value: '1' },
        { label: '质量要求', value: '2' },
      ],
      isPassList:[
        { label: '合格', value: 'Y' },
        { label: '部分合格', value: 'P' },
        { label: '不合格', value: 'N' },
      ],
      checkedTab:'Y',
      newCheckedTab:'Y',
      oldCheckedTab:'Y',
      reasonList:[],
      checkedList:[],
      checkArr:[],
      hasChanged:false, // 是否拖动
    };
  },
  watch: {
    checkedTab(newValue,oldValue) {
      this.newCheckedTab = newValue
      this.oldCheckedTab = oldValue
    },
    dialogIssues(val) {
      this.hasChanged = false
    }
  },
  created() {
    this.getList();
    // 获取按钮权限
    this.getMenuList()
  },
  methods: {
    toBulkCopy() {
      this.$router.push({
        path:'/checkConfigListToCopy',
        query:{
          productGuid:this.$route.query.productGuid
        }
      })
    },
    search() {
      let self = this;
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task/evaluation/list`, this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    emptySearch() {
      this.page = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        evaluationContent: '',
        tenantGuid: localStorage.guid,
      };
      this.getList();
    },
    addVersion() {
      this.textTitle = '新增考核内容';
      this.evaluationContent = '';
      this.orderNum = '';
      this.dialogVisible = true;
    },
    editVersion(detail) {
      this.textTitle = '编辑考核内容';
      this.dialogVisible = true;
      this.guid = detail.guid;
      this.evaluationContent = detail.evaluationContent;
      this.orderNum = detail.orderNum;
    },
    getList() {
      let self = this;
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task/evaluation/list`, this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    delVersion(guid) {
      var self = this;
      self
        .$confirm('删除后不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.api.postJson(`/${serverConfig.msSalesPerformService}/task/evaluation/del`, [guid]).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('删除成功');
              self.page.pageIndex = 1;
              self.getList();
            } else {
              self.$message.error(res.data.msg);
            }
          });
        });
    },
    addReqVersion() {
      var self = this;
      if (!this.evaluationContent) {
        self.$message.error('请输入考核内容');
        return;
      }
      if (!this.orderNum) {
        self.$message.error('请输入排序');
        return;
      }
      var req = {
        evaluationContent: this.evaluationContent,
        tenantGuid: localStorage.guid,
        orderNum: this.orderNum,
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task/evaluation/add`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogVisible = false;
          self.$message.success('新增成功');
          self.page.pageIndex = 1;
          self.getList();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    updateReqVersion() {
      var self = this;
      if (!this.evaluationContent) {
        self.$message.error('请输入考核内容');
        return;
      }
      if (!this.orderNum) {
        self.$message.error('请输入排序');
        return;
      }

      var req = {
        guid: this.guid,
        evaluationContent: this.evaluationContent,
        tenantGuid: localStorage.guid,
        orderNum: this.orderNum,
      };
      self.api.put(`/${serverConfig.msSalesPerformService}/task/evaluation/update`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogVisible = false;
          self.$message.success('修改成功');
          self.getList();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },
    setCheck(detail) {
      this.evaluationContent = detail.evaluationContent;
      this.taskEvaluationGuid = detail.guid;
      this.dialogCheckVisible = true;
      let self = this;
      let req = {
        pageIndex: 1,
        pageSize: -1,
        evaluationRuleDesc:this.evaluationRuleDesc,
        taskEvaluationGuid: detail.guid,
      };
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task/content/detail/list`, req).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if(res.data.data.records){
            self.evaluationTable = res.data.data.records;
            self.evaluationTable.forEach(item=>{
                 item.cutPayment = item.cutPayment+'';
                 item.award = +item.award+'';
                 item.cutRate = +item.cutRate+'';
                 item.awardRate = +item.awardRate+'';
            })
          }else{
            self.evaluationTable = [];
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getDetailList() {
      let req = {
        pageIndex: 1,
        pageSize: -1,
        evaluationRuleDesc:this.evaluationRuleDesc,
        taskEvaluationGuid: this.taskEvaluationGuid,
      };
      this.tableLoading = true;
      this.api.postJson(`/${serverConfig.msSalesPerformService}/task/content/detail/list`, req).then((res) => {
        this.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if(res.data.data.records){
            this.evaluationTable = res.data.data.records;
            this.evaluationTable.forEach(item=>{
                 item.cutPayment = item.cutPayment+'';
                 item.award = +item.award+'';
                 item.cutRate = +item.cutRate+'';
                 item.awardRate = +item.awardRate+'';
            })
          }else{
            this.evaluationTable = [];
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    saveEvaluationContent() {
      if(!this.evaluationTable||this.evaluationTable.length==0){
        this.$message.error('请新增考核机制！');
        return
      }
      try {
        this.evaluationTable.forEach((item) => {
          if (!item.evaluationType) {
            throw new Error('请填写考核类型！');
          }
          if (!item.evaluationRuleDesc) {
            throw new Error('请填写考核要求！');
          }
          if (item.evaluationType == 1 && !item.minQuantity) {
            throw new Error('请填写最低数量要求！');
          }
          if (item.evaluationType == 2 && !item.isPass) {
            throw new Error('请选择是否合格！');
          }
        });
      } catch (e) {
        this.$message.error(e.message);
        return;
      }
      var self = this;
      var evaluationTable = this.evaluationTable;
       evaluationTable.forEach(item=>{
          item.cutPayment = +item.cutPayment;
          item.award = +item.award;
          delete item.isDeleted
      })
      var req = {
        guid:this.taskEvaluationGuid,
        evaluationContent:this.evaluationContent,
        tenantGuid:localStorage.tenantGuid,
        taskEvaluationDetail:evaluationTable,
      }

      self.api.put(`/${serverConfig.msSalesPerformService}/task/evaluation/save-or-update`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogVisible = false;
          self.$message.success('保存成功');
          self.dialogCheckVisible = false;
          self.getList();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    addRow(index) {
      this.evaluationTable.push({
        taskEvaluationGuid: this.taskEvaluationGuid,
        evaluationType: '',
        orderNum: '',
        evaluationRuleDesc: '',
        minQuantity: '',
        cutPayment: '',
        award: '',
        isPass:'',
        // ruleTag:'',
        evaluationContent:this.evaluationContent,//考核内容
        guid:''
      });
    },
    delRow(index) {
      this.evaluationTable.splice(index, 1);
    },
    changeTab(val) {
      if (this.hasChanged) {
        this.$confirm('您的修改还未保存, 确定切换吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          this.hasChanged = false
          this.getRules(val)
        }).catch(() => {
          this.checkedTab = this.oldCheckedTab // 还原
        });
      } else {
        this.getRules(val)
      }
    },
    // ! 数组分类
    getReasonList(arr) {
      if (!arr.length) return [];
      let map = {};
      let res = [];
      for (let i = 0; i < arr.length; i++) {
        let item = arr[i];
        if (!map[item.evaluationContent]) {
          map[item.evaluationContent] = [item];
        } else {
          map[item.evaluationContent].push(item);
        }
      }
      Object.keys(map).forEach((key) => {
        res.push({
          evaluationContent: key,
          list: getSortList(map[key],'childOrderNum','升序'),
        });
      });

      return res;
    },
    getRules(approvalState) {
      this.fullscreenLoading = true
      let param = {
        pageSize: -1,
        pageIndex: 1,
        isPass:approvalState,
        tenantGuid:localStorage.guid
      }
      this.api
        .postJson(`/${serverConfig.msSalesPerformService}/task/content/detail/list`, param)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.fullscreenLoading = false
            if (res.data.data) {
              this.reasonList = Array.isArray(res.data.data.records) ? this.getReasonList(res.data.data.records.filter(item=>item.evaluationRuleDesc)) : [];
            } else {
              this.reasonList = [];
            }
          } else {
            this.$message.error(res.data.msg);
          }
      });
    },
    draggableStart(arr) {
      this.checkArr = arr
    },
    getSort({ oldIndex, newIndex }) {
      const targetRow = this.checkArr.splice(oldIndex, 1)[0]; // 获取第一条数据
      this.checkArr.splice(newIndex, 0, targetRow);
      // 将数组进行深拷贝，置空后重新赋值给数组
      let newArr = this.checkArr.splice(0);
      this.checkArr = []; // 置空
      this.checkArr = newArr;
      this.checkArr.forEach((item,index)=>{item.childOrderNum = index})
      this.hasChanged = true
    },
    // 排序后提交的list
    getResList() {
      let arr = []
      this.reasonList.forEach(reasonCategory=>{
        reasonCategory.list.forEach(reasonItem=>{
          if (!arr.find(item=>item.guid === reasonItem.guid)) {
            arr.push(reasonItem)
          } 
        })
      })
      return arr
    },
    confirmSort() {
      this.fullscreenLoading = true
      let res = this.getResList()
      console.log(res);
      let param = res.map(item=> { 
          const obj = {
            guid:item.guid,
            taskEvaluationGuid:item.taskEvaluationGuid,
            evaluationContent:item.evaluationContent,
            childOrderNum:item.childOrderNum
          }
          return obj
      })
      this.api
        .postJson(`/${serverConfig.msSalesPerformService}/task/content/detail/batch-update-detail`, param)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.fullscreenLoading = false
            this.hasChanged = false
            this.$message.success('保存成功');
          } else {
            this.$message.error(res.data.msg);
          }
      });
    }
  },
};
</script> 
<style lang="less" scoped>
.el-table /deep/ .el-input__inner {
  height: 28px;
  line-height: 28px;
}
.el-range-editor.el-input__inner {
  padding: 0px;
}
/deep/ .el-checkbox__label {
  display: none;
}
.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}
.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}
/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}
/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
/deep/ .el-dialog__footer {
  padding: 7px 20px 7px;
  border-top: 1px solid #d9d9d9;
  text-align: center;
}
/deep/ .el-dialog__header {
  border-bottom: 1px solid #d9d9d9;
}
/deep/ .el-input__icon {
  line-height: 28px;
}
/deep/ .el-dialog__body {
  padding: 8px 24px 0 24px;
  .el-form-item {
    margin-bottom: 12px;
  }
}
.content-main-box {
  height: 100%;
}
.sort-btn {
  background-color: #fff;
  color: #4fa1a4;
}
.dialog-title {
  text-align: center;
  width: 100%;
  height: 27px;
  font-family: PingFang SC;
  font-size: 18px;
  color: #212121;
  letter-spacing: 0;
  line-height: 27px;
  font-weight: 700;
}
.reason-title {
  text-align: left;
  width: 240px;
  height: 27px;
  font-family: PingFang SC;
  font-size: 15px;
  color: #212121;
  letter-spacing: 0;
  line-height: 27px;
  font-weight: 550;
  padding-left: 20px;
}
.reason-content {
  text-align: left;
  width: 400px;
  height: 27px;
  font-family: PingFang SC;
  font-size: 14px;
  color: #666;
  letter-spacing: 0;
  line-height: 27px;
  padding-left: 40px;
  .reason-content-item {
    cursor: move;
  }
}
.dialogCon-checkbox {
  max-height: 550px;
  overflow-y: auto;
}

</style>
<style >
.check-table-input .el-input__inner{
  text-align: right !important;;
}
</style>